import React from "react";
var __jsx = React.createElement;
import { convertToRaw } from 'draft-js';
import { useCallback } from 'react';
import styled from 'styled-components';
import { transformDraftjsToGenericState } from 'components/common/RichTextEditor/transformer';
import { transformGenericToDraftjsState } from 'components/common/RichTextEditor/transformer/transformGenericToDraftjs';
import { getSpacing } from 'stylesheet';
var DebugButtonsContainer = styled.div.withConfig({
  displayName: "DebugButtons__DebugButtonsContainer",
  componentId: "sc-1qvsezp-0"
})(["padding:", ";"], getSpacing(5));

var DebugButtons = function DebugButtons(_ref) {
  var editorState = _ref.editorState;
  var logEditorState = useCallback(function () {
    console.log(editorState.toJS());
    console.log(convertToRaw(editorState.getCurrentContent()));
  }, [editorState]);
  var logGenericEditorState = useCallback(function () {
    console.log(transformDraftjsToGenericState(editorState.getCurrentContent()));
  }, [editorState]);
  var logGenericToDraftjsEditorState = useCallback(function () {
    console.log(convertToRaw(transformGenericToDraftjsState(transformDraftjsToGenericState(editorState.getCurrentContent()))));
  }, [editorState]);
  return __jsx(DebugButtonsContainer, null, __jsx("button", {
    type: "button",
    onClick: logEditorState
  }, "Log EditorState to the console"), __jsx("br", null), __jsx("button", {
    type: "button",
    onClick: logGenericEditorState
  }, "Log Generic Editor State to the console"), __jsx("br", null), __jsx("button", {
    type: "button",
    onClick: logGenericToDraftjsEditorState
  }, "Log Generic to Draftjs editor state to the console"));
};

export default DebugButtons;